module.exports = __webpack_public_path__ + "img/vertical_7_5_8023.831437fe.png";